import { useRef, useState } from "react";
import EmployeeForm from "../EmployeeForm/EmployeeForm";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoadingBtn from "../../../components/LoadingBtn/LoadingBtn";
import api from "../../../api/Api";
import sampleFile from "../../../components/uploads/employees_bulk_format.xlsx"

import { Box, Grid, Button, Typography, Divider, CircularProgress } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";

function EmployeeAdd() {
  const [loading, setLoading] = useState(false);
  const [excelFile, setExcelFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  

  const formRef = useRef();
  const navigate = useNavigate();

  // ✅ Single Employee Add
  const handleAdd = (data) => {
    setLoading(true);
    api.post("/api/employees", data)
      .then(() => {
        toast.success("Employee added successfully!");
        setTimeout(() => navigate("/employees"), 1000);
      })
      .catch((error) => {
        const message = error.response?.data?.message || "Something went wrong!";
        toast.error(message);
      })
      .finally(() => setTimeout(() => setLoading(false), 1000));
  };

  // ✅ Bulk Upload Excel
  const handleFileChange = (e) => {
    setExcelFile(e.target.files[0]);
  };

  const handleBulkUpload = async () => {
    if (!excelFile) {
      toast.error("Please select a file before uploading.");
      return;
    }

    setUploading(true);
    const formData = new FormData();
    formData.append("file", excelFile);

    try {
      await api.post("/api/employees/upload", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      toast.success("Bulk upload successful!");
      setExcelFile(null);
      setTimeout(() => navigate("/employees"), 1500);
    } catch (error) {
      const message = error.response?.data?.message || "Failed to upload file.";
      toast.error(message);
    } finally {
     setTimeout(() => setUploading(false), 1000)
    }
  };

  return (
    <>
      {/* <ToastContainer position="bottom-right" autoClose={3000} /> */}

      <div className="d-flex justify-content-between align-items-center mx-3">
        <Link to="/employees" className="btn btn-secondary my-3">
          ← Back
        </Link>
        <h3 className="text-center mt-3">Add Employee</h3>
        <div>
          <LoadingBtn
            type="button"
            text="Submit"
            loading={loading}
            onClick={() => formRef.current.submitForm()}
          />
        </div>
      </div>

      <div className="container" style={{ width: "900px" }}>
        {/* Bulk Upload Section */}
        <Box>

          <Divider sx={{ mb: 2 }} />
          <Grid container spacing={2} alignItems="center">
            <Typography variant="h6" gutterBottom color="text.secondary">
              Bulk Upload via Excel
            </Typography>
            {/* Upload Button */}
            <Grid item xs={12} sm={4}>
              <Button
                component="label"
                variant="outlined"
                startIcon={<CloudUploadIcon />}
                fullWidth
                sx={{ height: 56 }}
              >
                Upload Excel File
                <input
                  type="file"
                  hidden
                  accept=".xlsx,.xls,.csv"
                  onChange={handleFileChange}
                />
              </Button>
            </Grid>

            {/* Download Sample Button */}
            <Grid item xs={12} sm={4}>
              <a href={sampleFile} download style={{ textDecoration: "none" }}>
                <Button
                  type="button"
                  variant="contained"
                  fullWidth
                  sx={{ height: 56 }}
                >
                  Download Sample Excel
                </Button>
              </a>
            </Grid>

            {/* Upload Employees Button */}
            <Grid item xs={12} sm={4}>
              <Button
                type="button"
                variant="contained"
                fullWidth
                sx={{ height: 56 }}
                onClick={handleBulkUpload}
                disabled={!excelFile || uploading}
              >
                {uploading ? <CircularProgress size={24} /> : "Upload Employees"}
              </Button>
            </Grid>

            {excelFile && (
              <Grid item xs={12}>
                <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
                  <InsertDriveFileIcon color="primary" sx={{ mr: 1 }} />
                  <Typography variant="body2">{excelFile.name}</Typography>
                </Box>
              </Grid>
            )}
          </Grid>

        </Box>

        {/* Single Employee Form */}
        <div className="container" style={{ width: "900px", height: '370px', overflowY: 'auto' }}>
          <EmployeeForm ref={formRef} onSubmit={handleAdd} />
        </div>
      </div>
    </>
  );
}

export default EmployeeAdd;
